import axios from "axios";

const REACT_APP_API = process.env.REACT_APP_API_BASE_URL;

export const ApprovalRequest = async (params) => {
  try {
    const response = await axios.post(
      `${REACT_APP_API}/api/Organization/Approval/CreateApprovalRequest`,
      params,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in Create Approval Request:", error);
    throw error;
  }
};
